import { ErrorToast, SuccessToast, WarningToast } from "../Admin/Components/ToastComponent/RectHotToast";
import { Addition } from "./CalculationsWithDecimalValues";
import { GetTodaysDateINdmy } from "./GetTodaysDate";
import { convertToISO } from "./IsoDateTime";
const TransactionCheck = async (
  transactions,
  TypeOfPortal,
  Closeformfunction,
  setTrasactionData,
  settoggle,
  toggle,
  setNotesdata,
  setAllFieldsData,
  close,
  data,
  allFieldsData,
  Mutation,
  selectedRows,
  dispatch,
  tableData,
  FormDataFromRedux,
  Form_Key,
  BookingkeyName,
  initialState
) => {
  let filteredArray;
  let CrSum = 0,
    DrSum = 0;

  console.log(tableData, "tableDatatableData", transactions);
  if (TypeOfPortal !== "Delete" && TypeOfPortal !== "Lock" && TypeOfPortal !== "Unlock") {
    if (!data?.Date) {
      WarningToast("Enter Date..!");
      return;
    }
    let transactionArr = [];
    let arr = [];
    let check = false;
    console.log(transactions);
    filteredArray = transactions.map((element, i) => {
      let fieldName = element?.name;

      if (
        FormDataFromRedux?.MasterData[Form_Key] &&
        (!FormDataFromRedux?.MasterData[Form_Key]?.[fieldName]?.Account_Balance_Id ||
          !element.Amount ||
          element.Amount === "0")
      ) {

        return null;
      } else {
        let id = FormDataFromRedux?.MasterData[Form_Key]?.[fieldName]?.Account_Balance_Id;
        console.log(id);
        if (arr.length === 0 && !id) {
          check = 1;
          return;
        }
        if (arr.includes(id)) {
          WarningToast("You have Selected Same Account More than One time...!");
          check = true;
          return;
        }
        arr.push(id);
        element.Account_ID = id;
      }
      let References = (tableData[element.id] ? Object.keys(tableData[element.id]) : []).map((key) => {
        let obj = {};
        let flag = true;
        tableData[element.id][key].forEach((item) => {
          // if (item.name === "Unique_Id") {
          //   return;
          // }
          if (item.name === "RefDate") {
            obj = {
              ...obj,
              [item.name]: convertToISO(item.value),
            };
          } else if (item.name === "Particular") {
            if (!item.value) {
              flag = false;
            }
            obj = {
              ...obj,
              [item.name]: item.value,
            };
            if (item?.NewRef_Id) {
              obj = { ...obj, NewRef_Id: item.NewRef_Id };
            }
          } else {
            obj = { ...obj, [item.name]: item.value };
          }
        });
        // if (flag) {
        return obj;
        // }
      });
      References = References.filter((el) => el);
      console.log(element, element.Transaction_Type === "Credit");
      if (element.Transaction_Type === "Credit") {

        CrSum = Addition(CrSum, Number(element.Amount));
      } else if (element.Transaction_Type === "Debit") {
        DrSum = Addition(DrSum, Number(element.Amount));
      }

      transactionArr.push({
        Account: {
          _id: element?.Account_ID,
          Account_Name: element?.[element["name"]],
        },
        Account_ID: element?.Account_ID,
        Amount: element?.Amount,
        Transaction_Type: element?.Transaction_Type,
        Serial_No: i,
      });

      // console.log(FormDataFromRedux?.MasterData[Form_Key]?.[fieldName]);
      let Balance_Method = FormDataFromRedux?.MasterData[Form_Key]?.[fieldName]?.Balance_Method
      return {
        Transaction_Type: element.Transaction_Type,
        Amount: Number(element.Amount),
        Account_ID: element.Account_ID,
        Serial_No: i + 1,
        ...(Balance_Method === "Bill By Bill" || Balance_Method === true ? { References } : {}),
        // References: references[element.id],
        // References: References,
      };
    });
    //   ...(Balance_Method === "Bill By Bill" || Balance_Method === true ? { References } : {}),
    // if (check === "Amount") {
    //   WarningToast("Create Transactions Properly");
    //   return;
    // }
    if (check === 1) {
      WarningToast("Create Transactions..");
      return;
    }
    if (check) {
      return;
    }
    console.log(filteredArray);
    filteredArray = filteredArray.filter((element) => {
      return element;
    });
    data = {
      ...data,
      Ref_No: data.Ref_No ? String(data.Ref_No) : "",
      TransactionsData: transactionArr,
    };
  }
  if (TypeOfPortal === "Edit") {
    console.log(CrSum, DrSum);
    if (CrSum !== DrSum) {
      WarningToast("Credit And Debit Should be equal");
      return;
    }
    if (!data.File) {
      data = { ...data, File: allFieldsData.File };
    }
    await Mutation({
      variables: {
        id: allFieldsData?._id,
        userInput: data,
        Transactions: filteredArray,
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        if (BookingkeyName === "Payment") {
          dispatch({ type: "SET_PAYMENT_DETAILS", payload: res?.data?.editVoucherEntries });
        } else if (BookingkeyName === "Receipt") {
          dispatch({ type: "SET_RECEIPT_DETAILS", payload: res?.data?.editVoucherEntries });
        }
        SuccessToast("Voucher Edited Successfully");
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  } else if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    let idsToLock = [];
    let idsToUnLock = [];

    if (selectedRows?.length > 0) {
      selectedRows.forEach((doc) => {
        if (doc.Is_Lock) {
          idsToUnLock.push(doc._id);
        } else {
          idsToLock.push(doc._id);
        }
      });
    }
    // const ArrayOfID = selectedRows.map((obj) => obj._id);
    await Mutation({
      variables: {
        idsToUpdate: TypeOfPortal === "Lock" ? idsToLock : idsToUnLock,
        Is_Lock: TypeOfPortal === "Lock" ? true : false,
      },
    })
      .then((res) => {
        const { message } = Object.values(res?.data)[0];
        SuccessToast(message);
        dispatch({ type: "Refetch", payload: true });
        Closeformfunction();
      })
      .catch((err) => ErrorToast(err.message));
  } else if (TypeOfPortal === "Delete") {
    const ArrayOfID = selectedRows.map((obj) => {
      return obj._id;
    });

    await Mutation({
      variables: { idsToDelete: ArrayOfID },
    })
      .then((res) => {
        SuccessToast("Voucher Deleted");
        dispatch({ type: "Refetch", payload: true });
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  } else if (CrSum === DrSum) {
    await Mutation({
      variables: {
        createInput: data,
        Transactions: filteredArray,
      },
    })
      .then((res) => {

        if (BookingkeyName === "Payment") {
          dispatch({ type: "SET_PAYMENT_DETAILS", payload: res?.data?.createVoucherEntries });
        } else if (BookingkeyName === "Receipt") {
          dispatch({ type: "SET_RECEIPT_DETAILS", payload: res?.data?.createVoucherEntries });
        }
        setTrasactionData(initialState?.length ? [...initialState] : []);
        setNotesdata("");
        setAllFieldsData({ Date: GetTodaysDateINdmy() });
        dispatch({ type: "CleartableData", payload: {} });
        SuccessToast("Voucher Added");
        dispatch({ type: "Refetch", payload: true });
        if (close === "Close" || TypeOfPortal === "Copy") {
          Closeformfunction();
        }
      })
      .catch((err) => {
        settoggle(toggle);
        ErrorToast(err.message);
      });
  } else {
    console.log(CrSum, DrSum);
    WarningToast("Credit And Debit Should be equal");
  }
};

export default TransactionCheck;
